import type { HeadlineProps } from '@/core/components/headline/headline';

import React from 'react';

import { Headline } from '@/core/features';

export default function HeadlineDesktop(props: HeadlineProps) {
    return (
        <Headline
            fontSize={18}
            marginBottom={20}
            {...props}
        />
    );
}
